<template>
  <!-- 法院公告 -->
  <div>
    <block>
      <div id="courtCount" style="position: relative;height: 0;overflow: hidden;top: -120px;"></div>
      <div class="table-list-title dis-bet-cen">
        <div>法院公告 <span style="color: #5D6FE9;">{{page.total}}</span></div>
      </div>
      <el-table
        border
        :data="TableData"
        :cell-style="cellStyle"
        :header-cell-style="headerColor"
        style="width: 100%;">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column v-for="(item,index) in tableHeader" :key="index" :label="item.label" :property="item.property" align="center">
          <template #default="scope">
            <span>{{scope.row[scope.column.property] || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="publishdate"
          label="刊登日期"
          width="120">
        </el-table-column>
        <el-table-column
            label="操作"
            width="80">
            <template #default="scope">
             <el-button type="text" @click="handleTo(scope.row)">详情</el-button>
            </template>
          </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          hide-on-single-page="true"
          :page-size="10"
          :pager-count="7"
          layout="prev, pager, next"
          v-model:currentPage="page.pageNum"
          @current-change="pageChange"
          :total="page.total">
        </el-pagination>
      </div>
      <el-dialog title="法院公告详情" :append-to-body="appendtobody" v-model="dialogTableVisible">
        <el-descriptions class="margin-top"  :column="2" :size="size" border>
          <!-- <el-descriptions-item :span="1">
            <template #label>当事人</template>
            <div style="width: 250px;">{{companyDetail.party || '-'}}</div>
          </el-descriptions-item> -->
          <el-descriptions-item :span="1">
            <template #label>上诉人</template>
            {{companyDetail.prosecutorList || '-'}}
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>公告类型</template>
            {{companyDetail.category || '-'}}
          </el-descriptions-item>
          <!-- <el-descriptions-item :span="1">
            <template #label>上传时间</template>
            {{companyDetail.submitdate || '-'}}
          </el-descriptions-item> -->
          <el-descriptions-item :span="1">
            <template #label>刊登日期</template>
            {{companyDetail.publishdate || '-'}}
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>刊登版面</template>
            <div >{{companyDetail.publishpage || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>公告法院</template>
            <div >{{companyDetail.court || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>案件年份</template>
            <div >{{companyDetail.publishGov || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>内容</template>
            <div style="width: 500px;">{{companyDetail.content || '-'}}</div>
          </el-descriptions-item>
        </el-descriptions>
      </el-dialog>
    </block>
  </div>
</template>

<script>
import { forwardBG } from '@/api/forward.js'
export default {
  name: 'court-count',
  props: { companyId: String },
  data () {
    return {
      appendtobody: true,
      companyDetail: {},
      dialogTableVisible: false,
      page: {
        total: 0,
        pageNum: 1
      },
      // 股东信息
      tableHeader: [{
        label: '法院公告',
        property: 'court'
      }, {
        label: '当事人',
        property: 'party'
      }, {
        label: '公告类型',
        property: 'category'
      }, {
        label: '上诉人',
        property: 'prosecutorList'
      }],
      TableData: []
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    handleTo (e) {
      this.dialogTableVisible = true
      const vm = this
      const data = {
        dateBackgroundUrl: '/companyCredit/getCourtNoticeDetail',
        dateBackgroundRequestType: 'get',
        data: {
          id: e.id
        }
      }
      forwardBG(data).then(result => {
        if (result.code === 0) {
          const res = result.data
          res.submitdate = res.submitdate ? res.submitdate.substring(0, 10) : '-'
          res.publishdate = res.publishdate ? res.publishdate.substring(0, 10) : '-'
          res.prosecutorList = res.prosecutorList ? JSON.parse(res.prosecutorList)[0].Name : '-'
          vm.companyDetail = res
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 表格设置样式
    headerColor: function ({ row, column, rowIndex, columnIndex }) {
      return 'background-color:#E8EBFC;color:#666666;font-size:14px;text-align:center'
    },
    cellStyle: function ({ row, column, rowIndex, columnIndex }) {
      return 'text-align:center'
    },
    pageChange (e) {
      this.page.pageNum = e
      this.initData()
    },
    initData: function () {
      const vm = this
      const data = {
        dateBackgroundUrl: '/companyCredit/getCourtNoticeList',
        dateBackgroundRequestType: 'get',
        data: {
          qcc_company_id: vm.companyId,
          pageNum: vm.page.pageNum,
          pageSize: 10
        }
      }
      forwardBG(data).then(result => {
        if (result.code === 0) {
          const res = result.data
          const arr = []
          vm.page.total = res.total
          res.list.forEach(item => {
            item.prosecutorList = item.prosecutorList ? JSON.parse(item.prosecutorList)[0].Name : '-'
            item.publishdate = item.publishdate ? item.publishdate.substring(0, 10) : '-'
            arr.push(item)
          })
          vm.TableData = arr
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped="scoped" lang="less">
.table-list-title {
  padding: 18px 0;
  text-align: left;
  color: #333;
  font-weight: bold;
}
.table-page {
  text-align: right;
  margin-top: 10px;
}
</style>
